<div class="d-flex align-items-center" *ngIf="!parent.isLoading">

  <div class="filtro-tipo ml-4 mr-4">
    <mat-form-field>
      <mat-select [disableControl]="parent.exibirGrid" [(ngModel)]="tipoFiltro" placeholder="Tipo Filtro"
        (selectionChange)="handleacaoGeral($event)">
        <mat-option *ngFor="let opt of tipoFiltroOpts" [value]="opt">
          {{opt.descricao}} </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <button type="button" mat-icon-button (click)="clearFieldsDoc()" [hidden]="!parent.exibirGrid || tipoFiltro?.id!=1"
    matTooltip="Limpar Pesquisa">
    <i class="fas fa-eraser eraser-button"></i>
  </button>
  <div class="flex-grow"> </div>

  <button class="ml-3 mb-3 mr-4" mat-flat-button color="primary" *ngIf="parent.acaoGeral.id != 1"
    [disabled]="!parent.exibirGrid" (click)="gerarViaFiltro()" matTooltip="Avançar" [hidden]="tipoFiltro?.id!=2">
    Prosseguir com Resultado de Pesquisa <i class="fas fa-arrow-right"></i>
  </button>

  <!-- <a style="cursor:pointer" mat-icon-button color="primary" (click)="handleacaoGeral()"
    matTooltip="Pesquisar">
    <label  style="margin-bottom: 0px !important">
      <i class="fas fa-search search-button cursor-pointer-icon"></i>
    </label>
  </a> -->
</div>
<mat-card class="filtros-header" [hidden]="parent.isLoading || tipoFiltro?.id">
  <mat-card-header class="header-padrao">
    <mat-card-title>
      <div class="filtro-acoes d-flex flex-wrap align-items-center">
        <p>Selecione uma opção de filtro para prosseguir...</p>
      </div>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p class="help-block">
      É possível realizar a ação através de upload de planilha ou via busca avançada.
    </p>
  </mat-card-content>
</mat-card>
<mat-card class="filtros-header" [hidden]="parent.isLoading || tipoFiltro?.id!=1">
  <mat-card-header class="header-padrao" [hidden]="parent.exibirGrid">
    <mat-card-title>
      <h3>{{tipoFiltro?.descricao}}</h3>
      <div class="filtro-acoes d-flex flex-wrap align-items-center">
        <div>
          <mat-form-field class="example-full-width">
            <mat-label>Arquivo</mat-label>
            <input matInput disabled [value]="filename">
          </mat-form-field>
        </div>

        <button mat-fab color="primary" aria-label="Selecionar arquivo" (click)="fileUpload.click()">
          <mat-icon>attach_file</mat-icon>
        </button>

        <input type="file" #fileUpload [(ngModel)]="fileInput" id="fileUpload" name="fileUpload" accept=".xls, .xlsx"
          (change)="loadFile($event)" hidden />



        <button class="ml-3 mr-4" mat-flat-button color="primary" (click)="uploadLote()" matTooltip="Avançar"
          [hidden]="!file || parent.exibirGrid || tipoFiltro?.id!=1">
          <i class="fas fa-upload"></i>&nbsp;Prosseguir por Upload de Arquivo
        </button>
      </div>
      <p>
        <span style="cursor:pointer" matTooltip="Download de planilha modelo" (click)="downloadTemplate()">
          <i class="fas fa-download"></i>&nbsp;Baixar arquivo de guia (template)
        </span>
      </p>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p class="help-block" [hidden]="parent.exibirGrid">
      Selecione um arquivo e clique em avançar para executar via upload de planilha.
    </p>
    <p class="help-block" [hidden]="!parent.exibirGrid">
      Exibindo resultado da pesquisa - Arquivo {{parent.nomeArquivo}}
    </p>
  </mat-card-content>
</mat-card>
<mat-card class="filtros-header" [hidden]="parent.isLoading || tipoFiltro?.id!=2">
  <mat-card-header class="header-padrao pt-0">
    <mat-card-title>
      <form class="d-flex flex-wrap align-items-center" [formGroup]="formPesquisa" style="padding-top:35px">
        <mat-form-field>
          <mat-label>Data Autorização (de):</mat-label>
          <input matInput autocomplete="off" maskDate [matDatepicker]="dtEmissaoIni" formControlName="dtEmissaoIni"
            required maskDate>
          <mat-datepicker-toggle matSuffix [for]="dtEmissaoIni"></mat-datepicker-toggle>
          <mat-datepicker #dtEmissaoIni></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Data Autorização (até):</mat-label>
          <input matInput autocomplete="off" maskDate [matDatepicker]="dtEmissaoFim" formControlName="dtEmissaoFim"
            required maskDate>
          <mat-datepicker-toggle matSuffix [for]="dtEmissaoFim"></mat-datepicker-toggle>
          <mat-datepicker #dtEmissaoFim></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Filial Emissão:</mat-label>
          <mat-select formControlName="filialEmissaoCodigo" placeholder="Filial Emissão">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let r of listaFilialEmissao" [value]="r.cnpj">
              {{ r.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Número CT-e:</mat-label>
          <input matInput placeholder="Número CTe" formControlName="numCTE" maxlength="20" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Chave CT-e:</mat-label>
          <input matInput placeholder="Chave CT-e" formControlName="chaveCTE" maxlength="44" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Tipo CTe:</mat-label>
          <mat-select formControlName="tipoCteId" placeholder="Tipo CTe">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let r of listaTipoCTE" [value]="r.id">
              {{ r.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field>
          <mat-label>Tipo Processamento:</mat-label>
          <mat-select formControlName="tipoProcessamentoId" placeholder="Tipo Processamento">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let r of listaTipoProcessamento" [value]="r.id">
              {{ r.tipoProcessamento }}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <mat-form-field>
          <mat-label>Status CTe:</mat-label>
          <mat-select formControlName="statusId" placeholder="Status CTe">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let r of listaStatusCTE" [value]="r.id">
              {{ r.status }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Status Cancelamento:</mat-label>
          <mat-select formControlName="tipoStatusCancelamentoId" placeholder="Status Cancelamento">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let r of listaStatusCancelamento" [value]="r.id">
              {{ r.status }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Clientes:</mat-label>
          <mat-select formControlName="clienteId" placeholder="Cliente" (selectionChange)="listarProdutos()">
            <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
                noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
              {{ cliente?.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Produtos:</mat-label>
          <mat-select [disableControl]="!clienteId || isLoading || !produtos?.length" formControlName="produtoId"
            placeholder="Produto">
            <mat-option><ngx-mat-select-search [formControl]="produtoMultiFilter" placeholderLabel="Buscar..."
                noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let produto of filteredProdutos | async" [value]="produto?.produtoID">
              {{ produto?.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Código de Barras</mat-label>
          <input matInput placeholder="Código de Barras" formControlName="nrtCodVolDoc" maxlength="20" />
        </mat-form-field>
        <button mat-icon-button (click)="clearFieldsDocFilter()" matTooltip="Limpar Campos">
          <i class="fas fa-eraser eraser-button"></i>
        </button>
        <button mat-icon-button (click)="trigger()" [disabled]="!validar() || formPesquisa.invalid">
          <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
        </button>
      </form>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p class="help-block">
      Selecione o filtro com intervalo de datas de até {{this.maxPeriodDataFiltro}} dias para realizar a pesquisa.
    </p>
    <!-- <div class=" p-2">
    <button mat-flat-button color="primary" [disabled]="!parent.gridCarregada" (click)="parent.acao(idAcao , null)">
      <span *ngIf="isLoading" class="d-flex align-items-center">
        <mat-spinner diameter="20" color="dark"></mat-spinner>
        &nbsp; Processando...
      </span>
      <span *ngIf="!isLoading">
        {{labelBtAvancar}}{{!parent.gridCarregada}}
      </span>
    </button>

  </div> -->
  </mat-card-content>
</mat-card>
